<template>
  <div id="publishing-special-issue">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Special Issues
      <div class="ipub-p1 right-option">
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY')"
                     type="primary"
                     @click="application">
          Special Issue Application
        </ipub-button>
        <ipub-button v-if="params.journalId&&user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.CREATE_NEW')"
                     type="primary"
                     @click="add">
          Add New Special Issue
        </ipub-button>
        <ipub-button :loading="loading"
                     type="primary"
                     @click="exp">
          Export
        </ipub-button>
        <!-- <ipub-button plain
                     type="primary"
                     @click="publish">
          Publish
        </ipub-button> -->
      </div>
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12, 16]">
          <ipub-col :span="2">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal"
                         :options="journalList" />
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.keyword"
                               placeholder="Search by Special Issue Title"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="[12, 16]"
                  v-if="showAdv">
          <ipub-col :span="6">
            <div class="flex">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">Start Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'StartTime')}"
                                      v-model="startDate" />
            </div>
          </ipub-col>
          <ipub-col :span="6">
            <div class="flex">
              <span class="line-h-40 ipub-p2 fw-bd nowrap">End Time</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width: 100%"
                                      :placeholder="['From','To']"
                                      @change="(e)=>{handleDateChange(e, 'EndTime')}"
                                      v-model="endDate" />
            </div>
          </ipub-col>
        </ipub-row>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>

    <div class="ipub-list-tab">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.released===''?'active':'']">All Status</a>
      <a @click="changeStatus(false)"
         :class="['ipub-list-tab--status',params.released===false?'active':'']">Pending Online</a>
      <a @click="changeStatus(true)"
         :class="['ipub-list-tab--status',params.released===true?'active':'']">Published</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="params.journalId?columns:allColumns"
                  fixed
                  :emptyText="params.released?'There is no special Issue which is published.':params.released===''?'There is no special Issue.':'There is no special Issue which is draft.'"
                  @order="setOrder"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:name="{record}">
          {{record.firstName}} {{record.lastName}}
        </template>
        <template v-slot:roles="{text}">
          {{editorialBoard[text]}}
        </template>
        <template v-slot:journal="{text}">
          {{text.name}}
        </template>
        <template v-slot:editor="{text}">
          <ipub-tooltip v-if="text&&text.length"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.map((item)=>{return item.firstName + ' '+ item.lastName}).join(', ')}`" />
          <template v-else>- -</template>
        </template>
        <template v-slot:publishedPaper="{record}">
          {{record.particleNum||0}} / {{record.articleNum||0}}
        </template>
        <template v-slot:status="{text}">
          <ipub-label size="small"
                      cover
                      style="width:80px"
                      type="success"
                      v-if="text">Published</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      cover
                      style="width:80px"
                      v-else>Draft</ipub-label>

        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip placement="bottomLeft"
                        action="click"
                        type="light"
                        class="border-right">
            <div class="hover-action-content"
                 style="font-size:14px"
                 slot="title">
              <div class="flex ipub-c-p"
                   @click="openWebsite(record)">
                <ipub-icon type="iconhtml" />
                Preview HTML
              </div>
              <div v-show="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DETAILS')"
                   class="flex ipub-c-p"
                   @click="article(record)">
                <ipub-icon type="iconSI_article" />
                Special Issue's articles
              </div>
            </div>
            <ipub-icon type="iconViewDetails" />
          </ipub-tooltip>
          <ipub-tooltip v-if="user.codeList&&(user.codeList.includes('WEBSITE.SPECIAL_ISSUES.EDIT')||(user.codeList.includes('WEBSITE.SPECIAL_ISSUES.UNPUBLISHED_EDIT')&&!record.released))"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template>
            <ipub-tooltip v-if="record.editorList&&record.editorList.length>0&&record.editorList.length<4&&user.codeList&&(user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DOWNLOAD_BANNER')||user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DOWNLOAD_FLYER'))"
                          class="border-right"
                          placement="bottomRight"
                          action="click">
              <div style="font-size:14px;"
                   class="hover-action-content"
                   slot="title">
                <div class="flex ipub-c-p"
                     v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DOWNLOAD_BANNER')"
                     @click="createCanvans(record, 'Banner')">
                  <ipub-icon type="iconBanner" />
                  Banner
                </div>
                <div class="flex ipub-c-p"
                     v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DOWNLOAD_FLYER')"
                     @click="createCanvans(record, 'Flyer')">
                  <ipub-icon type="iconFlyer" />
                  Flyer
                </div>
              </div>
              <ipub-icon type="iconGenerator" />
            </ipub-tooltip>
            <ipub-icon v-else
                       class="disabled-icon"
                       type="iconGenerator" />
          </template>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <CreateFile :isVisable="isVisablePDF"
                :inputData="inputData"
                :type="pdfType"
                :journalId="params.journalId"
                @confirm="cancel"
                @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
